import React, { useState, useEffect } from 'react'; import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import AppAppBar from '../components/AppAppBar';
import Footer from '../components/Footer';
import AppTheme from '../shared-theme/AppTheme';
import { Box, CircularProgress, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';

const GOOGLE_SHEET_URL = 'https://docs.google.com/spreadsheets/d/17ZMh8sx_kyHT6JSO6PlXlxxLNNaAvmHyMeI63V3yh5o/export?format=csv&id=17ZMh8sx_kyHT6JSO6PlXlxxLNNaAvmHyMeI63V3yh5o&gid=1534998441'; // Replace SPREADSHEET_ID
const fetchGoogleSheetData = async (sheetUrl) => {
    try {
        const response = await fetch(sheetUrl);
        if (!response.ok) throw new Error('Failed to fetch data from Google Sheets');
        const csvData = await response.text();

        // Parse CSV into JSON
        const rows = csvData.split('\n');
        const headers = rows[0].split(',');
        const data = rows.slice(1).map((row) => {
            const values = row.split(',');
            return headers.reduce((acc, header, index) => {
                acc[header.trim()] = values[index]?.trim();
                return acc;
            }, {});
        });

        return data;
    } catch (error) {
        console.error(error);
        return [];
    }
};

const Inventory = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loadData = async () => {
            const sheetData = await fetchGoogleSheetData(GOOGLE_SHEET_URL);
            setData(sheetData);
            setLoading(false);
        };

        loadData();
    }, []);

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
                <CircularProgress />
            </Box>
        );
    }

    return (
        <AppTheme>
            <CssBaseline enableColorScheme />
            <AppAppBar />
            <Box sx={{ pt: 15, px: 8 }}> {/* Increased padding-top and added background color */}
                <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold' }}>
                    Device Inventory
                </Typography> {/* Bold title with darker color for contrast */}

                <Typography variant="body1" paragraph sx={{ marginBottom: 4}}>
                    Below is a list of devices in my inventory. If you're interested in purchasing any of the devices for your institution or business, feel free to reach out to me directly. I'd be happy to discuss prices and answer any questions you may have.
                </Typography>

                {data.length > 0 ? (
                    <TableContainer component={Paper} sx={{ boxShadow: 3, borderRadius: 2 }}>
                        <Table>
                            <TableHead sx={{  }}>
                                <TableRow>
                                    {Object.keys(data[0]).map((header) => (
                                        <TableCell key={header} sx={{ fontWeight: 'bold', color: '#fff' }}>
                                            {header}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {data.map((row, index) => (
                                    <TableRow key={index}>
                                        {Object.values(row).map((value, idx) => (
                                            <TableCell key={idx}>{value}</TableCell>
                                        ))}
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                ) : (
                    <Typography sx={{ marginTop: 2, fontStyle: 'italic' }}>No data available</Typography>
                )}
            </Box>
            <Divider sx={{ marginTop: 4 }} />
            <Footer />
        </AppTheme>
    );
};

export default Inventory;